// Messages for operator/shipments/NotifyCustomerModal (auto-merged by lib/i18n.ts).
export const en = {
  'operator.notify_modal.title': 'Notify customer',
  'operator.notify_modal.cancel': 'Cancel',
  'operator.notify_modal.send': 'Send notification',
  'operator.notify_modal.this_customer': 'This customer',
  'operator.notify_modal.the_customer': 'the customer',
  'operator.notify_modal.no_recipients':
    "{name} has no portal users yet, so there's no one to notify. Invite a portal user first.",
  'operator.notify_modal.sends_one': "Sends an in-app notification to {name}'s portal user.",
  'operator.notify_modal.sends_many':
    "Sends an in-app notification to {name}'s portal users ({count}).",
  'operator.notify_modal.message_label': 'Message (optional)',
  'operator.notify_modal.message_aria': 'Notification message',
  'operator.notify_modal.message_placeholder': 'Leave blank to send a standard status update…',
}

export const zhTW = {
  'operator.notify_modal.title': '通知客戶',
  'operator.notify_modal.cancel': '取消',
  'operator.notify_modal.send': '傳送通知',
  'operator.notify_modal.this_customer': '此客戶',
  'operator.notify_modal.the_customer': '客戶',
  'operator.notify_modal.no_recipients':
    '{name}尚無入口使用者，因此沒有對象可通知。請先邀請入口使用者。',
  'operator.notify_modal.sends_one': '向{name}的入口使用者傳送應用程式內通知。',
  'operator.notify_modal.sends_many': '向{name}的入口使用者（{count}）傳送應用程式內通知。',
  'operator.notify_modal.message_label': '訊息（選填）',
  'operator.notify_modal.message_aria': '通知訊息',
  'operator.notify_modal.message_placeholder': '留空以傳送標準狀態更新…',
}
